function App() {
    window.location.href = 'https://app.classpoint.io/auth/signup';

    return null;
}

export default App;
